import { useState, useEffect, useCallback } from 'react';
import {
    addLandrEventListener,
    broadcastLandrEvent,
    LandrEventType,
} from '@landr/core';
import { DeviceCodeAuthorizationStep } from './types';

export const useDeviceCodeAuthorization = () => {
    const [step, setStep] = useState<DeviceCodeAuthorizationStep>(
        DeviceCodeAuthorizationStep.WaitingToStart,
    );
    const [isDeviceAuthorizationOpen, setIsDeviceAuthorizationOpen] =
        useState(false);
    const [deviceAuthorizationCode, setDeviceAuthorizationCode] =
        useState<string>();
    const [deviceAuthorizationUrl, setDeviceAuthorizationUrl] =
        useState<string>();

    useEffect(() => {
        const subscriptions = [
            addLandrEventListener(
                LandrEventType.DeviceAuthorizationWaitingStart,
                () => {
                    setIsDeviceAuthorizationOpen(true);
                    setStep(
                        DeviceCodeAuthorizationStep.StartDeviceAuthorization,
                    );
                },
            ),
            addLandrEventListener(
                LandrEventType.DeviceAuthorizationStarted,
                ({ url, code }) => {
                    setDeviceAuthorizationCode(code);
                    setDeviceAuthorizationUrl(url);
                },
            ),
            addLandrEventListener(
                LandrEventType.DeviceAuthorizationEnded,
                () => {
                    setIsDeviceAuthorizationOpen(false);
                },
            ),
        ];

        return () => subscriptions.forEach((unsubscribe) => unsubscribe());
    }, []);

    const startDeviceAuthorization = useCallback(() => {
        setStep(DeviceCodeAuthorizationStep.DeviceCodeAuthorization);
    }, []);

    const cancel = useCallback(() => {
        broadcastLandrEvent(
            LandrEventType.DeviceAuthorizationCancel,
            undefined,
        );
        setStep(DeviceCodeAuthorizationStep.WaitingToStart);
        setDeviceAuthorizationCode(undefined);
        setDeviceAuthorizationUrl(undefined);
    }, []);

    return {
        cancel,
        deviceAuthorizationCode,
        deviceAuthorizationUrl,
        isDeviceAuthorizationOpen,
        startDeviceAuthorization,
        step,
    };
};
